export default {
    handler: {
        dismiss: {
            subject: "即將放棄註冊",
            text: "請確認後執行"
        }
    }
}
